module.exports = __webpack_public_path__ + "static/media/scanner-beep-major-scale-up.c0feb14f.ogg";